import * as ActionTypes from '../actions/actionTypes';

export default function reduce(state={}, action) {
    state = Object.assign({}, state);
    switch (action.type) {
        case ActionTypes.SET_LAST_ENTRYID:
            // eslint-disable-next-line no-case-declarations
            const { EntryId } = action.payload;
            return Object.assign({}, state, { EntryId });
        default:
            return state;
    }
    // eslint-disable-next-line no-unreachable
    return state;
}


// WEBPACK FOOTER //
// ./components/response-handlers/form-interaction/reducers/index.js